export default "__VITE_ASSET__DLXFJJhg__"